/**
 * Route guard — renders children only if the user is authenticated
 * and optionally holds a required service role.
 * If not authenticated, stores the path for post-login redirect.
 *
 * Moved from services/auth/ProtectedRoute.tsx to atoll/components/.
 */
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { selectAuthenticated, selectUserHasRole, setReturnLocation, setLoginOpen } from '../redux/authSlice';
import { useAppSelector, useAppDispatch } from '../../services/redux/hooks';

export function ProtectedRoute({ children, path, requiredService, requiredRole }: {
  children: React.ReactNode,
  path: string,
  requiredService?: string,
  requiredRole?: string,
}) {
  const navigate = useNavigate();
  const isAuthenticated = useAppSelector(selectAuthenticated);
  const hasRole = useAppSelector((state) =>
    requiredService && requiredRole
      ? selectUserHasRole(state, requiredService, requiredRole)
      : true
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isAuthenticated) {
      dispatch(setReturnLocation(path));
    }
  }, [isAuthenticated, navigate, dispatch, path]);

  return isAuthenticated && hasRole ? children : null;
}

export default ProtectedRoute
